module.exports = __webpack_public_path__ + "static/media/notes.3fe530c8.png";